export default __webpack_public_path__ + "static/media/rank-curve-white.fa5033b0.svg";